// Turns the stable 403 bodies every service and llm-proxy emit for the org
// capabilities layer into user copy. FastAPI wraps its body in `detail`;
// llm-proxy returns the keys at the top level. Anything else -> null so the
// caller keeps its own generic message.
import { capabilityById } from '../config/capabilities';

export function deniedMessageFor(capabilityId) {
  const cap = capabilityById(capabilityId);
  return `Your organization administrator has not enabled ${cap ? cap.label : capabilityId} for your account.`;
}

export function capabilityDeniedMessage(body) {
  const d = body && typeof body === 'object' ? (body.detail ?? body) : null;
  if (!d || typeof d !== 'object') return null;
  if (d.error === 'capability_denied' && d.capability) return deniedMessageFor(d.capability);
  if (d.error === 'model_disabled' && d.model) return `The ${d.model} model is disabled by your organization's model policy.`;
  return null;
}
